<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Listado de Rubros</strong>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Listado de Rubros</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>    
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiRubros from "@/components/services/apiRubros";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";

import XLSX from "xlsx";

export default {
  name: "ListadoRubros",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      nombreexcel: "ListadoRubros",
      titles: [
        {
          prop: "CMRCODIGO",
          label: "Código Rubro",
          align: "center",
          minwidth:'50'
        },
        {
          prop: "CMRNOMBRE",
          label: "Nombre Rubro",
          align: "left",
          minwidth:'95'
        },
        {
          prop: "CMRCODSUB",
          label: "Código Sub Rubro",
          align: "center",
          minwidth:'50'
        },
        {
          prop: "CMRNOMSUB",
          label: "Nombre Sub Rubro",
          align: "left",
          minwidth:'100'
        }
      ],
      filters: [
        {
          prop: ["CMRCODIGO",
                "CMRNOMBRE",
                "CMRCODSUB",
                "CMRNOMSUB"
                 ],
          value: ""
        }
      ],

      mostrarFechas: true,
      datosFormulario: {},
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400
      },
    };
  },
  components:{
    Datepicker,
  },
  methods: {
    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      return apiRubros
        .pre_insercion_rubros(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      return apiRubros
        .recuperar_rubros(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then(response => {
          this.data  = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha Aviso" 
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property == "Provisión Benef. MonPol" 
              ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      }
      else if ((column.property == "Monto Impago Inicial MonPol" 
               ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format();
        }
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";

      for (var key in this.data) {
          
          if(this.data[key]["CMRCODIGO"] == undefined){
              this.data[key]["CMRCODIGO"] = "";
          }
          if(this.data[key]["CMRNOMBRE"] == undefined){
              this.data[key]["CMRNOMBRE"] = "";
          }
          if(this.data[key]["CMRCODSUB"] == undefined){
              this.data[key]["CMRCODSUB"] = "";
          }
          if(this.data[key]["CMRNOMSUB"] == undefined){
              this.data[key]["CMRNOMSUB"] = "";
          }
          
          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["CMRCODIGO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["CMRNOMBRE"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["CMRCODSUB"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["CMRNOMSUB"]+"</td>\n";

          cuerpo += "</tr>\n";
      }

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
